import React from 'react';
import { buildKeyFromStrings } from "../build-key-from-strings";
import { getParagraphsFromStrings } from "../get-paragraphs-from-strings";
import { Paragraph } from "../../components/typography/Paragraph";
export var getParagraphMarkup = function getParagraphMarkup(paragraphString) {
  return getParagraphsFromStrings(paragraphString).map(function (paragraphString, index) {
    return React.createElement(Paragraph, {
      key: buildKeyFromStrings(paragraphString, index)
    }, paragraphString);
  });
};